<script>
  import { mode } from "./stores/globalControls";
  import { fly } from "svelte/transition";
</script>

<div on:click={() => mode.set(null)} transition:fly={{ y: 100 }}>
  <h1>Mythic Atlas - Help</h1>

  <h2>About</h2>

  <h2>How to use</h2>
  <h3>Navigation</h3>
  <h3>Mode: Topography</h3>
  <h3>Mode: Colors</h3>
  <h3>Mode: Labels</h3>
  <h3>Mode: Effects</h3>

  <h2>Contributing</h2>

  <h2>Known issues</h2>

  <h2>Changelog</h2>

  <h2>Credits</h2>
  <ul>
    <li>
      Sticker icons from <a target="_blank" href="https://game-icons.net"
        >Game-icons.net</a
      >, by Lorc, Delapouite & contributors,
      <a target="_blank" href="http://creativecommons.org/licenses/by/3.0/"
        >CC BY 3.0</a
      >
    </li>
  </ul>
</div>

<style>
  div {
    --margin: 20px;
    position: absolute;
    left: 0;
    top: 0;
    width: calc(100% - var(--margin) * 2);
    height: calc(100% - var(--margin) * 2);
    margin: var(--margin);
    background: white;
    overflow-y: auto;
    z-index: 9999;
    /* Re-enable selection here; the rest of the app disables it (see App.svelte). */
    -webkit-user-select: text;
    user-select: text;
  }
</style>

